import Ad from "@components/Advertisement/Ad";
import Container from "@components/Container/Container";
import SeoFooter from "@components/Footer/SeoFooter/SeoFooter";
import { GADataProps } from "@components/GAData/GAData";
import Header from "@components/Header/Header";
import HomepageCarouselNewsletter from "@components/Newsletter/HomepageCarouselNewsletter";
import { useInjectClientData } from "@hooks/useInjectClientData";
import GarageArchivePageContent from "@routes/Newsletter/Archive/Garage/GarageArchivePageContent";
import { NewsletterArchivePageData } from "@routes/Newsletter/Archive/utils/types";

export default function NewsletterArchivePageContent({
  articles,
  seoFooterData,
  newsletterType,
  gaProps,
}: NewsletterArchivePageData & { gaProps: GADataProps }): React.ReactElement {
  useInjectClientData({ gaProps });

  return (
    <div className="w-full" data-testid="garage-archive-page-content-component">
      <Ad
        adType="lb1"
        className="flex min-h-[calc(50px+0.50rem)] flex-col items-center justify-center border-b border-gray-175 bg-gray-125 py-1 text-center md:py-3 lg:min-h-[calc(250px+1.5rem)]"
      />

      <Header />

      <Container rootClassName="pt-6">
        <GarageArchivePageContent articles={articles} />

        <HomepageCarouselNewsletter
          newsletterToSkip={newsletterType}
          blockTitle="YOU MAY LIKE"
          rootClassName="border-t border-gray-250 md:border-black pt-3 mb-16"
        />
      </Container>

      <SeoFooter data={seoFooterData} />

      <Ad adType="catfish" />

      <Ad adType="prestitial" />
    </div>
  );
}
